import { createContext, Dispatch, ReactNode, useMemo, useReducer } from 'react';
import { useParams } from 'react-router-dom';
import {
  VaultDetailReducer,
  initialState,
  InitialStateType,
} from './context-reducer';

type VaultDetailProviderProps = {
  children: ReactNode;
};

export const VaultDetailContext = createContext<{
  state: InitialStateType;
  dispatch: Dispatch<any>;
}>({
  state: initialState,
  dispatch: () => null,
});

const init = (state: InitialStateType, vaultId: number) => ({
  ...state,
  vaultId,
});

export const VaultDetailProvider = ({ children }: VaultDetailProviderProps) => {
  const { id: urlVaultId } = useParams<{ id: string }>();
  const [state, dispatch] = useReducer(VaultDetailReducer, initialState, (s) =>
    init(s, Number(urlVaultId)),
  );
  const providerValue = useMemo(() => ({ state, dispatch }), [state, dispatch]);
  return (
    <VaultDetailContext.Provider value={providerValue}>
      {children}
    </VaultDetailContext.Provider>
  );
};
